<template>
    <div>
        <el-input-number controls-position="right" :value="value" :class="{ 'is-error': isError }" v-bind="props" @input="inputHandler" />
        <span v-if="props.unit" class="unit">{{ props.unit }}</span>
    </div>
</template>

<script>
export default {
    name: "NumberInput",
    props: ["value", "widget", "verifyInfo", "rules", "validation"],
    computed: {
        props() {
            return this.widget.props;
        },
        isError() {
            return this.verifyInfo && this.verifyInfo.isValid === false;
        }
    },
    methods: {
        inputHandler(newValue) {
            if (newValue == null && this.props.min) {
                newValue = this.props.min;
            }
            this.$emit("change", newValue);
            this.verifyHandler(newValue);
        },
        verifyHandler(newValue) {
            if (!this.rules.some(rule => rule.required)) {
                return;
            }

            const verifyInfo = newValue != null && newValue !== "" ? { isValid: true, message: "" } : { isValid: false, message: "请输入必要内容" };
            this.$emit("verify", verifyInfo);
        }
    }
};
</script>

<style scoped lang="less">
.is-error {
    /deep/ input {
        border: 1px solid #f33535;
    }
}
.unit {
    margin: 0 0 0 8px;
}
</style>
